<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>アナウンス変更</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info btn_right" v-on:click="back">キャンセルする</button>
        <button id="destroyBtn" type="button" class="btn-sm btn-outline-danger btn_right" v-on:click="destroy">削除する</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="modify">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>内容</label>
              </div>
              <div class="col-9">
                <textarea v-model="announce.announce" class="textarea" placeholder="アナウンス内容" rows="3" cols="60"></textarea>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>通知開始日時</label>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <input type="date" class="form-control" v-model="announce.startDate" min="1900-01-01" max="2100-01-01">
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <input type="time" class="form-control" v-model="announce.startTime">
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>通知終了日時</label>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <input type="date" class="form-control" v-model="announce.endDate" min="1990-01-01" max="2100-12-31">
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <input type="time" class="form-control" v-model="announce.endTime">
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>対象</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="announce.type">
                  <option value=""></option>
                  <option value="1">{{allTenant}}</option>
                  <option value="2">{{selectTenant}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="isSelectHospitals">
            <div class="row">
              <div class="col-3">
                <button type="button" class="btn btn-sm btn-outline-primary" v-on:click="openModal">追加する</button>
              </div>
              <div class="col-9">
                <table class="table table-sm table-hover form-table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th scope="col" style="width:80px"></th>
                      <th scope="col">Code</th>
                      <th scope="col">名称</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="target in targets" v-bind:key="target.hospitalId">
                      <td>
                        <button type="button" class="btn-sm" v-on:click="remove(target.hospitalId)">
                          <img class=times-solid src="/times-solid.svg">
                        </button>
                      </td>
                      <td>{{ target.hospital.hospitalCode }}</td>
                      <td>{{ target.hospital.hospitalName }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <button id="modify_button" type="submit" class="btn btn-info btn btn-block">更新する</button>
        </form>
      </div>
    </div>
    <HospitalModal v-show="showContent" v-on:close-modal="closeModal" v-on:add-target="addTarget($event)" v-bind:targets="targets" v-bind:parentName="name" v-bind:exclusionId="announceId" v-bind:realms="realms"/>
  </div>
</template>

<script>
import axios from 'axios'
import HospitalModal from './../../components/HospitalModal'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Modify',
  mixins: [sessions,path,headers],
  props: ['realms','serviceName'],
  components: {
    HospitalModal
  },
  data: function(){
    return {
      name: 'announce',
      message: '',
      announce: {
        announce: '',
        startDate: '',
        startTime: '',
        endDate: '',
        endTime: '',
        type: ''
      },
      targets: [],
      announceId: this.$route.params.id,
      showContent: false,
    }
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    },
    isSelectHospitals: function () {
      return this.announce.type == 2
    },
    allTenant:function (){
      return this.serviceName === 'SmartPhone' ? '全ての事業所' : '全ての病院'
    },
    selectTenant:function (){
      return this.serviceName === 'SmartPhone' ? '事業所を選択する' : '病院を選択する'
    },
  },
  mounted() {
    this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var announceId = this.$route.params.id;
        axios.get("/api/announce/" + announceId, {
          headers: this.headers(accessToken)
        }).then(response => {
          this.announce = response.data.data.announce;
          this.targets = response.data.data.targets;
        }).catch(err => {
          this.message = err.message
        })
      }
    }).catch(err => {
      this.message = err.message
    })
  },
  methods: {
    remove(id) {
      var index = this.targets.findIndex((element) => element.announceId === id)
      this.targets.splice(index, 1)
    },
    modify() {
      var startAt = this.announce.startDate + ' ' + this.announce.startTime
      var endAt = this.announce.endDate + ' ' + this.announce.endTime
      if (!this.announce.type) {
        this.message = "対象が選択されていません"
        return
      }
      if (!this.announce.startDate || !this.announce.startTime) {
        this.message = "通知開始日時が入力されていません"
        return
      }
      if (!this.announce.endDate || !this.announce.endTime) {
        this.message = "通知終了日時が入力されていません"
        return
      }
      if (startAt > endAt) {
        this.message = "通知終了日時を変更してください"
        return
      }
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var url = this.announce.type == 1 ? "/api/announce/all" : "/api/announce/select"

          axios
            .put(url, {
            announce: this.announce,
            startAt: startAt,
            endAt: endAt,
            targets: this.targets
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert("更新されました。");
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/announce/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch(err => {
        this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/announce/index'))
    },
    destroy() {
      if(confirm('削除してもよろしいですか？')){
        this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var announceId = this.$route.params.id;
          axios.delete("/api/announce/" + announceId, {
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage;
            } else {
              alert('削除されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/announce/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }}).catch((err) => {
          this.message = err.message
        })
      }
    },
    openModal(){
      this.showContent = true
    },
    closeModal(){
      this.showContent = false
    },
    addTarget(event){
      this.targets = event
      this.closeModal()
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
.btn_right {
  float:right;
}
#destroyBtn {
  margin-right: 10px;
}
#modify_button {
  margin-top: 30px;
}
.times-solid{
  cursor: pointer;
  height: 15px;
  width: 15px;
}
.form-table{
  margin-top: 5px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>
